import { useEffect, useState } from "react";
import { api, fmtDateTime, relTime } from "@/lib/api";
import { Link } from "react-router-dom";
import { Warning } from "@phosphor-icons/react";

export default function Escalations() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/escalations"); setItems(data); };
  useEffect(() => { load(); }, []);
  const resolve = async (id) => { await api.post(`/escalations/${id}/resolve`); load(); };
  return (
    <div className="space-y-5" data-testid="escalations-page">
      <div>
        <div className="label-eyebrow">CEO Queue</div>
        <h1 className="font-display text-[28px] font-bold tracking-tight mt-1">Escalation Queue</h1>
        <div className="text-[12px] text-[var(--span-text-2)] mt-1">
          Auto-triggers: cases &gt; USD 10K · sensitive case types · multi-country
        </div>
      </div>

      <div className="card-flat">
        <table className="span-table">
          <thead>
            <tr><th></th><th>Case code</th><th>Reason</th><th>Priority</th><th>Status</th><th>Triggered</th><th></th></tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={7} className="py-6 text-center text-[12px] text-[var(--span-text-2)]">No escalations.</td></tr>}
            {items.map(e => (
              <tr key={e.escalation_id} data-testid={`esc-row-${e.case_code}`}>
                <td><Warning size={16} className={e.status === "open" ? "text-[var(--span-danger)]" : "text-[var(--span-text-2)]"} weight={e.status === "open" ? "fill" : "regular"} /></td>
                <td><Link className="font-mono text-[12px] font-semibold hover:underline" to={`/cases/${e.case_id}`}>{e.case_code}</Link></td>
                <td className="text-[12px]">{e.reason}</td>
                <td><span className={`badge ${e.priority === "high" ? "badge-danger" : "badge-warn"}`}>{e.priority}</span></td>
                <td><span className={`badge ${e.status === "resolved" ? "badge-success" : "badge-danger"}`}>{e.status}</span></td>
                <td className="text-[var(--span-text-2)] text-[12px]">{relTime(e.triggered_at)}<br/><span className="font-mono text-[10px]">{fmtDateTime(e.triggered_at)}</span></td>
                <td>
                  {e.status === "open" && <button onClick={() => resolve(e.escalation_id)} data-testid={`resolve-${e.escalation_id}`} className="span-btn span-btn-ghost h-7 text-[11px]">Resolve</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
